module.exports = __webpack_public_path__ + "img/logo-fundacion-forge.f133ba27.png";